export const importTool = {
  selectModel: "Select the type of data to import or export",
  export: {
    title: "Export - {{model}}",
    filters: "Filters",
    filterBy: {
      assets: "Asset id(s)",
      assetTypes: "Asset type id(s)",
      datasets: "Dataset id(s)",
      datasetTypes: "Dataset type(s)",
      interventions: "Intervention id(s)",
      locations: "Location id(s)",
      organizations: "Organization id(s)",
      projects: "Project id(s)",
      recommendations: "Recommendation id(s)",
      interventionTemplates: "Template id(s)",
      interventionTemplate: "Template",
    },
  },
  import: {
    selectFile: "Select a file",
    insertForm: {
      title: "Insert - {{model}}",
      label: "Insert new {{model}} from an XLSX file",
      submitButton: "Insert new {{model}}",
      exportTemplate: "Export template",
    },
    updateForm: {
      title: "Update - {{model}}",
      label: "Update existing {{model}} from an XLSX file",
      submitButton: "Update existing {{model}}",
    },
    alerts: {
      errorTitle: "One error on `{{attribute}}` column",
      errorTitle_other: "{{count}} errors on `{{attribute}}` column",
      ignoredHeadings: "The following columns will be ignored:",
      invalidHeadings: "The selected file's columns are not valid.",
      rowInserted: "one row inserted",
      rowInserted_other: "{{count}} rows inserted",
      rowInserted_zero: "0 row inserted",
      rowIgnored: "one row ignored",
      rowIgnored_other: "{{count}} rows ignored",
      rowIgnored_zero: "0 row ignored",
      rowUpdated: "one row updated",
      rowUpdated_other: "{{count}} rows updated",
      rowUpdated_zero: "0 row updated",
      successTitle: "Import successfully completed!",
      validHeadings: "The following columns will be imported:",
    },
  },
};
